/* eslint-disable sonarjs/cognitive-complexity */
import { Button } from '../../inputs/form';
import * as React from 'react';
import ReactModal from 'react-modal';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Image } from 'semantic-ui-react';
import JourneyLabel from '../../label/label';
import JourneyTitle from '../../label/title';

// import { TranslationProps } from '../../../i18n/types/translationProps';
// import WithCoreProps from '../../../hocs/withCoreProps';
// import CoreHelper from '../../../helpers/coreHelper';
import { TranslationProps, WithCoreProps, CoreHelper } from 'ff-shared-components-core';

import { modalClose, modalHide } from '../../../store/modals/modal/actions';
import { Modal } from '../../../store/modals/modal/types';
import { ModalButton } from './types';
import ImagePlaceholder from '../../layout/imagePlaceholder';
import { ModalInnerContainer, ModelContentContainer, StyledIconContainer } from './style';
import './styles.less';
import { ModalButtonType, ModalType } from './types';
import { Theme } from '../../../theme/types';
import defaultTheme from '../../../theme/defaultTheme';
import { styled } from '@theme';
import { Table, ColType, TableAppearance } from '@shared/components';

interface ModalAlertProps {
	/** set modal identifier */
	modalId?: string;
	/** set children content of modal */
	iconImage?: string;
	/**set a close icon  */
	closeImage?: string;
}

interface ModalAlertInjectedProps extends TranslationProps {
	showModal: boolean;
	theme: Theme;
	modal: Modal;
	modalsVisibility: any;
	closeModal(): void;
	hideModal(modalId: string): void;
}

interface JourneyButtonProps {
	primary?: boolean;
	secondary?: boolean;
	key?: string;
}

export const ButtonRedContainer = styled.div`
	> button {
		border: none;
		border-radius: 0;
		max-width: 100%;
	}
`;

// bind modal to appElement
ReactModal.setAppElement('body');

class ModalAlertComponent extends React.Component<ModalAlertProps & ModalAlertInjectedProps> {
	public constructor(props: ModalAlertProps & ModalAlertInjectedProps) {
		super(props);
		// this.handleCloseModal = this.handleCloseModal.bind(this);
	}

	// public handleCloseModal = (): void => {
	// 	console.log('MODAL > handleCloseModal');
	// 	const { closeModal } = this.props;
	// 	closeModal();
	// };

	private handleOnAfterOpenModal = (): void => {
		const scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
		const body = document.body;
		body.style.position = 'fixed';
		body.style.top = `-${scrollY}`;
	};

	private handleOnCloseModal = (): void => {
		const { closeModal } = this.props;
		closeModal();

		const body = document.body;
		const scrollY = body.style.top;
		body.style.position = '';
		body.style.top = '';
		window.scrollTo(0, parseInt(scrollY || '0') * -1);
	};

	public AddJourneyButton(button: ModalButton, customProps: JourneyButtonProps): JSX.Element {
		return (
			<Button
				data-test="modal-button"
				text={button.text}
				// big
				// fixed
				onClick={
					button.onClick
						? (e): void => {
								button.onClick && button.onClick(e);
								button.closeOnClick && this.handleOnCloseModal();
						  }
						: this.handleOnCloseModal
				}
				{...customProps}
			/>
		);
	}

	public render(): JSX.Element | null {
		const {
			showModal,
			modalsVisibility,
			modal,
			modalId,
			theme: propsTheme,
			iconImage,
			closeImage,
			closeModal,
			hideModal,
		} = this.props;
		const theme = CoreHelper.mergeObjects(defaultTheme, propsTheme);
		const children: React.ReactNode = modal ? (modal.children ? modal.children : null) : null;
		if (modalId) {
			// if (!children || !modalId) {
			// 	return null;
			// }
			if (!modalId) {
				return null;
			}
			const visibility = modalsVisibility[modalId] || false;
			if (!visibility) {
				return null;
			}

			return (
				<ReactModal
					className="ModalAlert"
					overlayClassName="ModalAlertOverlay"
					shouldCloseOnOverlayClick={false}
					onAfterOpen={this.handleOnAfterOpenModal}
					onRequestClose={this.handleOnCloseModal}
					isOpen={true}
				>
					{closeImage && (
						<div
							style={{
								textAlign: 'right',
								position: 'absolute',
								right: '16px',
								top: '16px',
								zIndex: 999,
							}}
							onClick={() => hideModal(modalId)}
						>
							<img src={closeImage} style={{ width: 20, height: 20 }} />
						</div>
					)}
					​
					{/* {iconImage && (
						<StyledIconContainer company={company}>
							<div>
								<img src={iconImage} />
							</div>
						</StyledIconContainer>
					)} */}
					​
					{closeImage ? (
						<div style={{ marginTop: '32px' }}>
							<ModalInnerContainer data-test="modal-alert">{modal}</ModalInnerContainer>
						</div>
					) : (
						<ModalInnerContainer data-test="modal-alert">
							{
								<Table
									columnsWidth={[ColType.extraBig, ColType.normal, ColType.normal]}
									appearance={TableAppearance.primary}
									withSuffix
									// hasError={customers.length === 0}
									// rows={customers}
									// pathToRedirect="/sns-now-resolve-now/movement-detail"
								/>
							}
						</ModalInnerContainer>
					)}
				</ReactModal>
			);
		}

		if (!modal || showModal === false) {
			return null;
		}

		const { type, okButton, customButtons, textMessage, title, textMessageIsHtml } = modal;
		const defaultOkButton = okButton ? (
			<Button
				data-test="modal-ok-button"
				text={okButton.text}
				onClick={okButton.onClick ? okButton.onClick : this.handleOnCloseModal}
				primary
				// big
				// fixed
			/>
		) : null;

		const customButtonsList =
			customButtons &&
			customButtons.map(
				(button: ModalButton, index: number): JSX.Element => {
					const buttonType =
						button.type === ModalButtonType.PRIMARY ? { primary: true } : { secondary: true };
					if (button.routeTo) {
						return (
							<Link
								data-test="button-link"
								key={index.toString()}
								to={button.routeTo}
								style={{ textDecoration: 'none' }}
							>
								{this.AddJourneyButton(button, { ...buttonType })}
							</Link>
						);
					}
					return this.AddJourneyButton(button, { ...buttonType, ...{ key: index.toString() } });
				}
			);

		let modalImage;
		switch (type) {
			case ModalType.ERROR:
				modalImage = theme.image.modalError;
				break;
			case ModalType.WARNING:
				modalImage = theme.image.modalWarning;
				break;
			case ModalType.INFO:
				modalImage = theme.image.modalWarning;
				break;
			case ModalType.SUCCESS:
				modalImage = theme.image.modalSuccess;
				break;
			default:
				modalImage = theme.image.modalWarning;
				break;
		}

		return (
			<div>
				<ReactModal
					className={`${children ? 'ModalAlert withTable' : 'ModalAlert'}`}
					overlayClassName="ModalAlertOverlay"
					isOpen={showModal}
					shouldCloseOnOverlayClick={false}
					onAfterOpen={this.handleOnAfterOpenModal}
					onRequestClose={this.handleOnCloseModal}
				>
					<ModalInnerContainer data-test="modal-alert">
						<ImagePlaceholder height="100px" margin="0 auto 20px">
							<Image data-test="modal-image" className="modalImage" src={modalImage} circular />
						</ImagePlaceholder>
						<ModelContentContainer>
							{title && <JourneyTitle title={title} center id15 width={80} marginBottom={10} />}
							<JourneyLabel
								data-test="text-message"
								text={textMessage}
								html={textMessageIsHtml ? true : false}
								center
								id8
							/>
							{children}
						</ModelContentContainer>
						​
						<div className="navContainer">
							<ButtonRedContainer>
								{defaultOkButton}
								{customButtonsList}
							</ButtonRedContainer>
						</div>
					</ModalInnerContainer>
				</ReactModal>
			</div>
		);
	}
}

const mapStateToProps = (state: any) => ({
	showModal: state.modalState.showModal,
	modal: state.modalState.modal,
	modalsVisibility: state.modalState.modalsVisibility,
});

const mapDispatchToProps = (dispatch: any) => ({
	closeModal: () => dispatch(modalClose()),
	hideModal: (modalId: string) => dispatch(modalHide(modalId)),
});

export const ModalAlert = WithCoreProps<ModalAlertProps>(
	connect(mapStateToProps, mapDispatchToProps)(ModalAlertComponent)
);
